define([
    "dojo/_base/declare",
    "csi",
    "csi/reflection",
    "csi/table/Widget"
], function(declare,csi,reflection,Widget) {

    return declare(Widget, {

        _resolveView: function() {
            var headings = this.defView.m_headings;
            var factoryConfig = reflection.getObject("centric://REFLECTION/INSTANCE/FactoryConfig");

            if (factoryConfig && factoryConfig.SingleSectionReview) {
                // if single section review setting is enabled remove Sections heading
                var hSections = csi.search(headings, function(h) { return h.m_id == "Sections"; });
                headings.dele(hSections);
            } else {
                // otherwise remove Subsections heading
                var hTemplateSubsections = csi.search(headings, function(h) { return h.m_id == "TemplatSubsections"; });
                headings.dele(hTemplateSubsections);
            }

            this.inherited(arguments);
        }
    });
});
